module.exports = __webpack_public_path__ + "6316419b0f007518e46738d153dccd96.svg";